import PropTypes from 'prop-types'
import styled from 'styled-components'

import { NOTIFICATION_TYPE_ERROR } from 'constants/notification'

import IconLink from 'components/Shared/IconLink/Index'

const StyledRefresh = styled.div`
  margin-left: 24px;
  height: 100%;
  margin-right: auto;
  display: flex;
  align-items: center;
  &:hover {
    font-weight: 600;
  }
`
StyledRefresh.displayName = 'StyledRefresh'

const StyledRefreshIcon = styled(IconLink)`
  width: 18px;
  margin-right: 4px;
`

const RefreshLink = ({ type }) => {
  if (type === NOTIFICATION_TYPE_ERROR) {
    return (
      <StyledRefresh
        onClick={() => { window.location.reload(true) }}
      >
        <StyledRefreshIcon iconName='icon-refresh-notification' />
      </StyledRefresh>
    )
  } else {
    return null
  }
}

RefreshLink.propTypes = {
  type: PropTypes.string,
}

export default RefreshLink
